import React, { useState, useEffect } from "react";
import "./menu.css";
import { getFilteredMenu } from "./menuPermissions";

export const gestionDeAlmacenMenu = [
  {
    title: "Dashboard",
    icono: "Dashboard.svg",
    enlace: "DashboardMain", // Corregido
    activo: "doméstico/dashboard",
    permiso: [5000],
    hijos: [],
  },
  {
    title: "Llegadas",
    icono: "Dashboard.svg",
    enlace: "#",
    activo: "doméstico/llegadas",
    permiso: [5001, 5002, 5003, 5004],
    hijos: [
      {
        title: "Vuelos",
        icono: "Dashboard.svg",
        enlace: "VuelosLlegadasCooler",
        activo: "doméstico/llegadas/vuelos",
        permiso: [5001],
      },
      {
        title: "Tiempos plataforma",
        icono: "Dashboard.svg",
        enlace: "TiemposPlataformaCooler",
        activo: "doméstico/llegadas/tiempos_plataforma",
        permiso: [5002],
      },
      {
        title: "Tiempos confronta",
        icono: "Dashboard.svg",
        enlace: "TiemposConfrontaCooler",
        activo: "doméstico/llegadas/tiempos_confronta",
        permiso: [5003],
      },
      {
        title: "Vale cooler",
        icono: "Dashboard.svg",
        enlace: "ValeCoolerSearcher",
        activo: "doméstico/llegadas/vale_cooler",
        permiso: [5004],
      },
    ],
  },
  {
    title: "Salidas",
    icono: "Dashboard.svg",
    enlace: "#",
    activo: "doméstico/salidas",
    permiso: [5005, 5006, 5007, 5008],
    hijos: [
      {
        title: "Captura Master",
        icono: "Dashboard.svg",
        enlace: "DomesticDepartureCapture",
        activo: "doméstico/salidas/captura_master",
        permiso: [5005],
      },
      {
        title: "Vale Cooler",
        icono: "Dashboard.svg",
        enlace: "DomesticDepartureCooler",
        activo: "doméstico/salidas/vale_cooler",
        permiso: [5006],
      },
      {
        title: "Tiempos armado",
        icono: "Dashboard.svg",
        enlace: "DomesticDepartureArmedTimes",
        activo: "doméstico/salidas/tiempos_armado",
        permiso: [5007],
      },
      {
        title: "Tiempos plataforma",
        icono: "Dashboard.svg",
        enlace: "DomesticDeparturePlatformTimes",
        activo: "doméstico/salidas/tiempos_plataforma",
        permiso: [5008],
      },
    ],
  },
  {
    title: "Catálogos",
    icono: "Dashboard.svg",
    enlace: "#",
    activo: "doméstico/catálogos",
    permiso: [5009],
    hijos: [
      {
        title: "Usuarios Cooler",
        icono: "Dashboard.svg",
        enlace: "DomesticCoolerUsers",
        activo: "doméstico/catálogos/usuarios_cooler",
        permiso: [5009],
      },
    ],
  },
  {
    title: "Reportes",
    icono: "Dashboard.svg",
    enlace: "#",
    activo: "doméstico/reportes",
    permiso: [5010, 5011, 5012, 5013, 5014, 5015, 5016],
    hijos: [
      {
        title: "Kardex",
        icono: "Dashboard.svg",
        enlace: "DomesticReportKardex",
        activo: "doméstico/reportes/kardex",
        permiso: [5011],
      },
      {
        title: "Inventario",
        icono: "Dashboard.svg",
        enlace: "DomesticReportInventario",
        activo: "doméstico/reportes/inventario",
        permiso: [5011],
      },
      {
        title: "Bitácora Cooler Por Guía",
        icono: "Dashboard.svg",
        enlace: "DomesticReportCoolerLogGuia",
        activo: "doméstico/reportes/bitácora_cooler_por_guía",
        permiso: [5012],
      },
      {
        title: "Bitácora cooler general",
        icono: "Dashboard.svg",
        enlace: "DomesticReportCoolerLogGeneral",
        activo: "doméstico/reportes/bitacora_cooler_general",
        permiso: [5013],
      },
      {
        title: "Pharma Llegadas",
        icono: "Dashboard.svg",
        enlace: "DomesticReportPharmaArrivals",
        activo: "doméstico/reportes/pharma_llegadas",
        permiso: [5014],
      },
      {
        title: "Pharma Salidas",
        icono: "Dashboard.svg",
        enlace: "DomesticReportPharmaDepartures",
        activo: "doméstico/reportes/pharma_salidas",
        permiso: [5015],
      },
      {
        title: "Carga de insumo",
        icono: "Dashboard.svg",
        enlace: "DomesticReportCargaInsumo",
        activo: "doméstico/reportes/carga_insumo",
        permiso: [5016],
      },
    ],
  },
];

export const getGestionDeAlmacenMenu = () =>
  getFilteredMenu(gestionDeAlmacenMenu);

const MenuItem = ({
  item,
  activePath,
  onSetActive,
  onHoverChange,
  hoveredItem,
  onComponentChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = item.hijos && item.hijos.length > 0;

  // Defensa: Asegura que activePath sea un string para evitar el error "undefined.startsWith"
  const currentPath = activePath || "";

  // Lógica para determinar el resaltado
  const isCurrentActive = item.activo === currentPath;
  const isAncestorActive =
    currentPath.startsWith(item.activo + "/") && !isCurrentActive;

  // Colapso automático/apertura si es parte del path activo
  useEffect(() => {
    if (isAncestorActive || isCurrentActive) {
      setIsOpen(true);
    }
  }, [isAncestorActive, isCurrentActive]);

  // Lógica de Hover (se mantiene)
  const isHighlighted = item.title === hoveredItem;
  const hoverProps = hasChildren
    ? {
        onMouseEnter: () => onHoverChange(item.title),
        onMouseLeave: () => onHoverChange(null),
      }
    : {};

  // FUNCIÓN CLAVE: Manejo de Clic y Notificación con Doble Argumento
  const handleItemClick = (e) => {
    // 1. Lógica de Colapso (Si tiene hijos)
    if (hasChildren) {
      e.preventDefault();
      setIsOpen(!isOpen);
    }

    // 2. Lógica de Navegación/Selección (Elementos hoja)
    else {
      e.preventDefault();

      if (onComponentChange) {
        sessionStorage.setItem(
          "currentModule",
          item.enlace !== "#" ? item.enlace : "",
        );
        // Notifica a Admin.js: Envía el Nombre del Componente y la Ruta Activa
        onComponentChange(item.enlace, item.activo);
      }

      // onSetActive ya no se llama localmente porque Admin.js lo maneja.
    }
  };

  // Determina las clases de estilo (se mantiene)
  let itemClass = "";
  if (isCurrentActive) {
    itemClass = "is-active";
  } else if (isAncestorActive) {
    itemClass = "is-ancestor";
  }

  return (
    <li
      className={`menu-item ${item.activo} ${itemClass} ${isHighlighted ? "highlighted" : ""}`}
      {...hoverProps}
    >
      <a
        href={item.enlace}
        onClick={handleItemClick}
        className={`
                    menu-link 
                    text-white 
                    px-3 d-flex 
                    justify-content-between 
                    align-items-center
                    ${item.enlace === sessionStorage.getItem("currentModule") ? "active" : ""}
                `}
      >
        {item.title}
        {hasChildren && <span className="arrow">{isOpen ? "▲" : "▼"}</span>}
      </a>

      {/* Llamada Recursiva: Pasamos todos los props necesarios */}
      {hasChildren && (
        <ul className="submenu" style={{ display: isOpen ? "block" : "none" }}>
          {item.hijos.map((child, index) => (
            <MenuItem
              key={index}
              item={child}
              activePath={activePath}
              onSetActive={onSetActive} // Dummy
              onHoverChange={onHoverChange}
              hoveredItem={hoveredItem}
              onComponentChange={onComponentChange} // <-- ¡Pasado recursivamente!
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const MenuDomestico = ({ activePath, onComponentChange }) => {
  // Estados locales (solo Hover)
  const [hoveredItem, setHoveredItem] = useState(null);
  const menuItems = getGestionDeAlmacenMenu();
  const handleHoverChange = (title) => {
    setHoveredItem(title);
  };

  // Función dummy para onSetActive (ya no gestiona el estado, solo cumple la firma)
  const handleSetActiveDummy = () => {};

  return (
    <nav className="menu-importacion">
      <ul className="menu-list">
        {menuItems.map((item, index) => (
          <MenuItem
            key={item.title || index}
            item={item}
            activePath={activePath} // <-- Recibido de Admin.js
            onSetActive={handleSetActiveDummy}
            onHoverChange={handleHoverChange}
            hoveredItem={hoveredItem}
            onComponentChange={onComponentChange} // <-- Función enviada al fondo
          />
        ))}
      </ul>
    </nav>
  );
};

export default MenuDomestico;
